import { useNavigate } from 'react-router-dom';

import { KeyTypeFigurant, StatusFigurant } from 'models';
import { cpfMask } from 'commons/utils';

import { KeySrcTypes, SRC_TYPES } from '../../@types';
import { PropsBuildAction } from '../../utils';
import * as S from '../../styles';
import * as CONSTANTS from '../../constants';

type Props = {
  missingInformation: boolean;
  selected: boolean;
  cardType: string;
  item: StatusFigurant;
  type: KeyTypeFigurant;
  figurantCpf?: string;
  pathname: string;
  colorSelectedFigurant: string;
  isAvailableToShowSelectButton: KeySrcTypes[];
  src: KeySrcTypes;
  isDisabled?: boolean;
  submitBySrc: Record<KeySrcTypes, PropsBuildAction>;
};

export const ActionBottom = ({
  cardType,
  item,
  missingInformation,
  selected,
  type,
  figurantCpf,
  pathname,
  isAvailableToShowSelectButton,
  src,
  colorSelectedFigurant,
  isDisabled,
  submitBySrc,
}: Props) => {
  const navigate = useNavigate();

  return (
    <>
      {!missingInformation && (
        <S.SeeMoreButton
          width="100%"
          variant="outlined"
          selected={selected}
          onClick={() => navigate(`/ver-mais/${cardType}/${item.id}`)}
        >
          ver mais
        </S.SeeMoreButton>
      )}
      {missingInformation && (
        <S.SeeMoreButton
          width="100%"
          variant="outlined"
          selected={selected}
          onClick={() => {
            localStorage.setItem('entity-type', item.entityType);
            navigate(`/${CONSTANTS.redirectToMissingInfo[type]}/${item.id}/editar`, {
              state: { entityType: item.entityType, pageOrigin: pathname, cpf: cpfMask(figurantCpf) },
            });
          }}
        >
          atualizar dados
        </S.SeeMoreButton>
      )}
      {isAvailableToShowSelectButton.includes(src) && (
        <S.SelectFigurantButton
          data-testid="action-button-figurant"
          width="100%"
          disabled={isDisabled}
          variant={selected && (item.isActive || item.statusBook === 'UNAVAILABLE') ? 'outlined' : 'contained'}
          $colorSelectedFigurant={colorSelectedFigurant}
          onClick={() => submitBySrc[src as SRC_TYPES]?.onClick(item)}
        >
          {submitBySrc[src as SRC_TYPES].text}
        </S.SelectFigurantButton>
      )}
    </>
  );
};
